<ol class="breadcrumbs-directive">
    @if (nodeExistsAndIsNotCollapsed(nodes.root)) {
        <li class="d-print-none">
            <adapt-display-navigation-node class="breadcrumb-text"
                                           [isInBreadcrumb]="true"
                                           [node]="nodes.root"></adapt-display-navigation-node>
            <i class="breadcrumb-separator"
               aria-hidden="true">/</i>
        </li>
    }
    @if (nodeExistsAndIsNotCollapsed(nodes.area)) {
        <li>
            <adapt-display-navigation-node class="breadcrumb-text"
                                           [isInBreadcrumb]="true"
                                           [node]="nodes.area"></adapt-display-navigation-node>
            <i class="breadcrumb-separator"
               aria-hidden="true">/</i>
        </li>
    }
    @for (node of nodes.branches; track node) {
        <li>
            <adapt-display-navigation-node class="breadcrumb-text"
                                           [isInBreadcrumb]="true"
                                           [node]="node"></adapt-display-navigation-node>
            <i class="breadcrumb-separator"
               aria-hidden="true">/</i>
        </li>
    }
    @if (atLeastOneNodeIsCollapsed()) {
        <li class="collapsed-node-indicator">
            <span class="me-1"
                  [adaptTooltip]="collapsedTooltip"
                  tooltipPlacement="bottom-left">...</span>
            <i class="breadcrumb-separator"
               aria-hidden="true">/</i>
        </li>
    }
    @if (nodeExistsAndIsNotCollapsed(nodes.leafParent)) {
        <li [ngClass]="{ 'd-print-none': nodes.leafParent && !nodes.root }">
            <adapt-display-navigation-node class="breadcrumb-text"
                                           [isInBreadcrumb]="true"
                                           [node]="nodes.leafParent"></adapt-display-navigation-node>
            <i class="breadcrumb-separator"
               aria-hidden="true">/</i>
        </li>
    }
    <li>
        <adapt-display-navigation-node class="breadcrumb-text breadcrumb-leaf"
                                       [node]="nodes.leaf"
                                       [isInBreadcrumb]="true"
                                       [linkToPage]="false"></adapt-display-navigation-node>
    </li>
</ol>
